import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./style.scss";

const TabSelect = ({ tab, selected, onSelect }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);

  const selectOption = (event, option, index) => {
    // only fire callback if option is different
    if (selectedIndex !== index || !selected) {
      try {
        onSelect(event, tab, { ...option, index });
      } catch (error) {
        console.error("no callback defined", error);
      }
    }
    setSelectedIndex(index);
  };

  const dropdownOptions = isSelected => {
    return tab.options.map((option, index) => {
      const optionClassList = classNames("option", {
        active: isSelected === index
      });
      return (
        <div
          key={option.value}
          className={optionClassList}
          onClick={e => selectOption(e, option, index)}
        >
          {option.label}
        </div>
      );
    });
  };

  const arrowIconClassList = classNames("tab-arrow", {
    open: showDropdown
  });

  return (
    <div
      className="tab-select"
      onClick={() => setShowDropdown(!showDropdown)}
      tabIndex={-1}
      onBlurCapture={e => {
        setTimeout(() => setShowDropdown(false), 150);
      }}
    >
      <div className="label">
        {tab.label}
        <span className={arrowIconClassList}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            width="24"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M7 10l5 5 5-5H7z" />
          </svg>
        </span>
      </div>

      {showDropdown && (
        <div className="options">{dropdownOptions(selected)}</div>
      )}
    </div>
  );
};

TabSelect.propTypes = {
  // selected: PropTypes.shape({
  //   label: PropTypes.string
  // }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  onSelect: PropTypes.func
};

TabSelect.defaultProps = {
  options: []
};

export default TabSelect;
